export enum mathTopic {
  ARITHMETIC = 'arithmetic',
  THE_TIMES_TABLES = 'the-times-tables',
  FRACTIONS = 'fractions',
  PARENTHESES = 'parentheses',
  UNITS_OF_MEASUREMENT = 'units-of-measurement',
  EXCHANGE_RATES = 'exchange-rates',
  PROBABILITY = 'probability',
  POWERS = 'powers',
  ALGEBRA = 'algebra',
  FUNCTIONS = 'functions',
  DIFFERENTIATION = 'differentiation',
  INTEGRATION = 'integration',
  GEOMETRY = 'geometry',
  TRIGONOMETRY = 'trigonometry',
  VECTORS = 'vectors',
  SPREADSHEETS = 'spreadsheets',
  GEOGEBRA = 'geogebra',
}
